module.exports = __webpack_public_path__ + "static/media/icon-txt.0838a20e.svg";